'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { OrderDetails } from 'my-purchases/types/purchaseDetail'

import styles from './StorePurchaseInfo.module.scss'

interface StorePurchaseInfoProps {
	readonly order: OrderDetails
}

export function StorePurchaseInfo({ order }: StorePurchaseInfoProps) {
	const { t } = useLabels()
	const { storeAddress, storeNumber } = order

	if (!storeAddress) {
		return null
	}

	return (
		<div className={styles.container}>
			<p>{`${t('my_purchases.receipt.details.storeNumber')} ${storeNumber}`}</p>
			<p>{`${storeAddress.address}, ${storeAddress.city}`}</p>
		</div>
	)
}
